import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { AllModuleDialogListComponent } from './components/dialog-list/dialog-list.component';
import { AllExecutionsListComponent } from './components/executions-list/executions-list.component';
import { AllModuleListComponent } from './components/list/list.component';
import { AllModulesService } from './services/all-modules-service';
import { AllModulesApiService } from './services/all-modules.api-service';

@NgModule({
    imports: [
        RouterModule,
        MaxBrainSharedModule,
        MatCheckboxModule,
        MatTableModule,
        MatMenuModule,
        MatSortModule,
        MatIconModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatPaginatorModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
    ],
    declarations: [AllModuleListComponent, AllModuleDialogListComponent, AllExecutionsListComponent],
    providers: [AllModulesService],
    exports: [AllModuleListComponent, AllModuleDialogListComponent, AllExecutionsListComponent],
})
export class MaxBrainAllModulesModule {
    static forRoot(): ModuleWithProviders<MaxBrainAllModulesModule> {
        return {
            ngModule: MaxBrainAllModulesModule,
            providers: [AllModulesApiService],
        };
    }
}
